module.exports = __webpack_public_path__ + "static/media/Screen_header.0ea33cb2.svg";